export default "__VITE_ASSET__Bb1FdYTx__"